/*
 * Copyright (c) Schrocken Inc.
 * Author: Harish
 * File Description: Sign Up components
 */

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter, Link } from 'react-router-dom';
import querystring from 'query-string';

import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';

import HeaderFooterwithCookies from '../../common/openPages/HeaderFooterwithCookies';
import AzureRedirect from '../azureLogin/AzureRedirectCard';
// import ContactAdmin from '../../common/ContactAdmin';
import { verifyAzureSignUp } from '../../../containers/actions/authActions';

class AzureSignUpRedirect extends Component {
  state = {
    tokenError: null,
  };
  componentDidMount() {
    const { search } = this.props.location;
    const parsed = querystring.parse(search);
    // get azure code and signup token from url params
    let azureAdCode = parsed.code;
    let signUpToken = parsed.state;

    this.props.verifyAzureSignUp(
      { azureAdCode, signUpToken },
      this.props.history,
      signUpToken
    );
  }
  componentDidUpdate(prevProps, prevState) {
    if (
      prevProps.invitedUserData !== this.props.invitedUserData &&
      this.props.invitedUserData.status === false
    ) {
      this.setState({
        loading: false,
        tokenError: this.props.invitedUserData.errorDescription,
      });
    }
  }
  render() {
    const { tokenError } = this.state;
    return (
      <HeaderFooterwithCookies>
        {tokenError !== null ? (
          <Grid
            container
            alignItems='center'
            justify='center'
            style={{ textAlign: 'center', marginTop: 100 }}
          >
            <Grid item xs={12} sm={12} md={12}>
              <Typography
                variant='body1'
                style={{ marginTop: '3rem', fontWeight: 500 }}
              >
                {tokenError}
              </Typography>
            </Grid>
            <Grid item xs={12} sm={12} md={12} style={{ paddingTop: '1rem' }}>
              {/* <ContactAdmin /> */}
              <Typography
                variant='body2'
                color='primary'
                style={{
                  display: 'inline',
                  textDecoration: 'underline',
                  cursor: 'pointer',
                  fontSize: '1rem',
                }}
                component={Link}
                to='/contactadmin'
              >
                Contact the ecosystem administrator for an invitation
              </Typography>
            </Grid>
          </Grid>
        ) : (
            <AzureRedirect />
          )}
      </HeaderFooterwithCookies>
    );
  }
}

const mapStateToProps = (state) => ({
  invitedUserData: state.auth.invitedUserData,
});
export default connect(mapStateToProps, { verifyAzureSignUp })(
  withRouter(AzureSignUpRedirect)
);
